import { request, postMultipart } from '../request';
import i18n from '@/plugins/i18n';
import { getCookie } from '@/utils/cookie';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { normalizeLanguage } from '@/jmHttp/index';

/** 与 jmHttp AxiosConfig.initHeaders 中 language 请求头一致（i18n → cookie → localStorage → navigator） */
function getLanguageHeader() {
  const language =
    i18n.global.locale.value ||
    getCookie(LOCAL_STORAGE_KEY.LANGUAGE) ||
    localStorage.getItem('lang') ||
    navigator.language;
  return normalizeLanguage(language);
}

export const skillApi = {
  listSkills: () =>
    request('/skills', {
      headers: {
        language: getLanguageHeader()
      }
    }),

  listSkillPoolSkills: () => request('/skills/pool'),

  listSkillWorkspaces: () => request('/skills/workspaces'),

  createSkillPoolSkill: (payload) =>
    request('/skills/pool/create', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  saveSkillPoolSkill: (payload) =>
    request('/skills/pool/save', {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),

  updatePoolSkillTags: (skillName, tags) =>
    request(`/skills/pool/${encodeURIComponent(skillName)}/tags`, {
      method: 'PUT',
      body: JSON.stringify(tags)
    }),

  deleteSkillPoolSkill: (skillName) =>
    request(`/skills/pool/${encodeURIComponent(skillName)}`, {
      method: 'DELETE'
    }),

  downloadSkillPoolSkill: (payload) =>
    request('/skills/pool/download', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  uploadWorkspaceSkillToPool: (payload) =>
    request('/skills/pool/upload', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  listPoolBuiltinSources: () => request('/skills/pool/builtin-sources'),

  importSelectedPoolBuiltins: (payload) =>
    request('/skills/pool/import-builtin', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  importPoolSkillFromHub: (payload) =>
    request('/skills/pool/import', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  uploadSkillPoolZip: (file, options) => postMultipart('/skills/pool/upload-zip', file, options || {}),

  createSkill: (skillName, content, config, enable) =>
    request('/skills', {
      method: 'POST',
      body: JSON.stringify({
        name: skillName,
        content: content,
        config,
        enable
      })
    }),

  saveSkill: (payload) =>
    request('/skills/save', {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),

  refreshSkills: () =>
    request('/skills/refresh', {
      method: 'POST'
    }),

  /** Workspace skill ZIP import (same semantics as CoPaw POST /skills/upload) */
  uploadWorkspaceSkillZip: (file, options) =>
    request('/skills/upload', file, {
      method: 'POST',
      enable: options?.enable !== false,
      overwrite: options?.overwrite === true,
      target_name: options?.target_name,
      rename_map: options?.rename_map
    }),

  batchDeleteSkills: (skillNames) =>
    request('/skills/batch-delete', {
      method: 'POST',
      body: JSON.stringify(skillNames)
    }),

  startHubSkillInstall: (payload) =>
    request('/skills/hub/install/start', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  getHubSkillInstallStatus: (taskId) => request(`/skills/hub/install/status/${encodeURIComponent(taskId)}`),

  cancelHubSkillInstall: (taskId) =>
    request(`/skills/hub/install/cancel/${encodeURIComponent(taskId)}`, {
      method: 'POST'
    }),

  enableSkill: (skillName) =>
    request(`/skills/${encodeURIComponent(skillName)}/enable`, {
      method: 'POST'
    }),

  disableSkill: (skillName) =>
    request(`/skills/${encodeURIComponent(skillName)}/disable`, {
      method: 'POST'
    }),

  batchEnableSkills: (skillNames) =>
    request('/skills/batch-enable', {
      method: 'POST',
      body: JSON.stringify(skillNames)
    }),

  deleteSkill: (skillName) =>
    request(`/skills/${encodeURIComponent(skillName)}`, {
      method: 'DELETE'
    }),

  updateSkillTags: (skillName, tags) =>
    request(`/skills/${encodeURIComponent(skillName)}/tags`, {
      method: 'PUT',
      body: JSON.stringify(tags)
    }),

  updateSkillChannels: (skillName, channels) =>
    request(`/skills/${encodeURIComponent(skillName)}/channels`, {
      method: 'PUT',
      body: JSON.stringify(channels)
    }),

  getSkillConfig: (skillName) => request(`/skills/${encodeURIComponent(skillName)}/config`),

  searchHubSkills: (query, limit = 20) => request(`/skills/hub/search?q=${encodeURIComponent(query)}&limit=${limit}`),

  installHubSkill: (payload) =>
    request('/skills/hub/install', {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  importSkill: (payload) =>
    request('/skills/import-from-url', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
};
